/************
 * Model Class
 * File Name ...: agencies.components.ts
 * Generated By : ianday on 10/10/23
 * Date ........: 10/10/23
 /************/
import {ValidationResult} from './validation-result';
import {DwUtils} from "../components/utils/dw-utils";

export interface Agencies {

    id: number;
    agencyCode: string | null;
    agencyName: string | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    county: string | null;
    primaryContact: string | null;
    secondaryContact: string | null;
    phoneNumber: string | null;
    phoneNumberSecondary: string | null;
    emailAddress: string | null;
    emailAddressSecondary: string | null
    activeStatus: string | null;
    hoursOfOperation: string | null;
}

export class Agencies {
    constructor() {
        this.id = 0;
        this.agencyCode = '';
        this.agencyName = '';
        this.address1 = '';
        this.address2 = '';
        this.city = '';
        this.state = '';
        this.zipCode = '';
        this.county = '';
        this.primaryContact = '';
        this.secondaryContact = '';
        this.phoneNumber = '';
        this.emailAddress = '';
        this.activeStatus = '';
        this.emailAddressSecondary='';
        this.phoneNumberSecondary='';
        this.hoursOfOperation = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.agencyName.length === 0) {
            vr.focus_field = 'agencyName';
            vr.error = 'Error: an Agency Name is required';
            return vr;
        }
        if (this.address1.length === 0) {
            vr.focus_field = 'address1';
            vr.error = 'Error: An address is required';
            return vr;
        }
        if (this.city.length === 0) {
            vr.focus_field = 'city';
            vr.error = 'Error: A city is required';
            return vr;
        }

        if (this.state.length === 0) {
            vr.focus_field = 'state';
            vr.error = 'Error: A state is required';
            return vr;
        }
        
         if (this.county.length === 0) {
            vr.focus_field = 'county';
            vr.error = 'Error: A county is required';
            return vr;
        }

        if (this.zipCode.toString().length !== 5) {
            vr.focus_field = 'zipCode';
            vr.error = 'Error: Invalid or blank zipCode should be five digits';
            return vr;
        }

        if (this.primaryContact.length === 0) {
            vr.focus_field = 'primaryContact';
            vr.error = 'Error: A primary contact name is required';
            return vr;
        }

        if (this.phoneNumber.length === 0) {
            vr.focus_field = 'phoneNumber';
            vr.error = 'Error: A phone number is required';
            return vr;
        }

        if (this.emailAddress.length === 0) {
            vr.focus_field = 'emailAddress';
            vr.error = 'Error: An email address is required';
            return vr;
        }

        if(DwUtils.validEmailAddress(this.emailAddress) === false) {
            vr.focus_field = 'emailAddress';
            vr.error = 'Error: Email address is not in the proper form';
            return vr;
        }
        if(this.emailAddressSecondary.length > 0) {
            if(DwUtils.validEmailAddress(this.emailAddressSecondary) === false) {
                vr.focus_field = 'secondEmailAddress';
                vr.error = 'Error: Secondary email Address is not in the proper form';
                return vr;
            }

            if(this.emailAddress === this.emailAddressSecondary) {
                vr.focus_field = 'emailAddress';
                vr.error = 'Error: Primary and secondary email addresses are the same!';
                return vr;
            }
        }

        return vr;
    }
}
